const tenantName = String(process.env.REACT_APP_TENANT_ID)
  .replace(/^\s+|\s+$/g, '')
  .toLowerCase()

export const isTenantMain = () => tenantName === 'citymatch'
export const isTenantDev = () => ['localhost', 'local', 'dev', 'development'].includes(tenantName)
export const isTenantCelepar = () => ['parananegocios', 'celepar'].includes(tenantName)
